import React from 'react';
import * as _ from 'lodash';
import { convertFlagToCircleOrCross } from '../../utilities/stringUtil';
import Tippy from '../../components/ReactTippy';
import moment from 'moment';
import '../../styles/organisms/partner-companies-table.scss';
/**
 * Tooltipで表示される文字
 * @param data {string}
 */
const renderTooltipContent = data => {
  const rowStyle = {
    maxWidth: '240px',
    wordWrap: 'break-word',
    color: '#FFF',
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
  };

  return (
    <React.Fragment>
      <div style={rowStyle}>{data}</div>
    </React.Fragment>
  );
};

/**
 * tooltip表示判定
 * @param {object} instance // tippy
 */
const setTippyHide = instance => {
  const showingTooltipLength = 15;
  instance.popper.hidden =
    instance.options.html.innerText.length < showingTooltipLength;
};

/**
 * 日時の文字列変換
 * @param date {string}
 */
const dateFormat = date => {
  return moment(date).format('YYYY/MM/DD HH:mm');
};

/**
 * 協力会社一覧テーブル部分
 * @param data {object} 一覧情報
 * @param callbacks {func}
 */
export const PartnerCompanyContents = ({ data, callbacks }) => {
  const styles = {
    icon: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  };
  return (
    <tbody className='PartnerCompanyContents'>
      {_.map(data, partnerCompany => (
        <tr className='table__item' key={partnerCompany.id}>
          <td className='value-table construction-list-value-table__branch-name'>
            <span className='label'>会社名</span>

            {/* tooltip */}
            <Tippy
              duration={10}
              distance={24}
              arrowType='sharp'
              delay={[500, 0]}
              placement='bottom'
              followCursor={true}
              html={renderTooltipContent(
                partnerCompany.name + partnerCompany.company_branch.name
              )}
              onShow={setTippyHide}
            >
              <div className='value-table__txt--10'>{`${partnerCompany.name} ${
                partnerCompany.company_branch.name
              }`}</div>
            </Tippy>
          </td>
          <td className='value-table construction-list-value-table__address'>
            <span className='label'>住所</span>
            <Tippy
              duration={10}
              distance={24}
              arrowType='sharp'
              delay={[500, 0]}
              placement='bottom'
              followCursor={true}
              html={renderTooltipContent(partnerCompany.address)}
              onShow={setTippyHide}
            >
              <div className='value-table__txt--10'>
                {partnerCompany.address}
              </div>
            </Tippy>
          </td>
          <td className='value-table construction-list-value-table__tel'>
            <span className='label'>電話番号</span>
            <div className='value-table__tel'>{partnerCompany.tel}</div>
          </td>
          <td className='value-table construction-list-value-table__date'>
            <span className='label'>登録日</span>
            <div className='value-table__date'>
              {dateFormat(partnerCompany.created_at)}
            </div>
          </td>
          <td className='value-table construction-list-value-table__date'>
            <span className='label'>更新日</span>
            <div className='value-table__date'>
              {dateFormat(partnerCompany.updated_at)}
            </div>
          </td>
          <td className='value-table construction-list-value-table__option'>
            <span className='label'>共通</span>
            <div className='value-table__icon' style={styles.icon}>
              {convertFlagToCircleOrCross(String(partnerCompany.joining_flag))}
            </div>
          </td>
          <td className='value-table construction-list-value-table__option'>
            <span className='label'>ユーザー数</span>
            <div className='value-table__count'>
              <span className='value-table__user'>
                <span className='value-table__user-role'>管理者：</span>
                <span className='value-table__user-count'>
                  {partnerCompany.partner_count}
                </span>
              </span>
              <span className='value-table__user'>
                <span className='value-table__user-role'>職長：</span>
                <span className='value-table__user-count'>
                  {partnerCompany.foreman_count}
                </span>
              </span>
              <span className='value-table__user'>
                <span className='value-table__user-role'>作業員：</span>
                <span className='value-table__user-count'>
                  {partnerCompany.worker_count}
                </span>
              </span>
            </div>
          </td>
          <td className='value-table value-table--button'>
            <div className='value-table__button-3'>
              <button
                className='btn--sm--stay'
                onMouseDown={() => callbacks.table.edit(partnerCompany)}
              >
                確認
              </button>
              <button
                className='btn-text--sm'
                onMouseDown={() => callbacks.table.list(partnerCompany)}
                style={{ whiteSpace: 'nowrap' }}
              >
                ユーザー確認
              </button>
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  );
};



// WEBPACK FOOTER //
// ./src/components/tables/PartnerCompanies.jsx